import { render, staticRenderFns } from "./ClinicShowCategory.vue?vue&type=template&id=1ab5c024"
import script from "./ClinicShowCategory.vue?vue&type=script&lang=js"
export * from "./ClinicShowCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports